module.exports = __webpack_public_path__ + "static/media/video01.e835dd0.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/video01.mp4
// module id = Kwtu
// module chunks = 18